export default __webpack_public_path__ + "static/hw_makerfabs-33f922a87ac052a3db09d7c23d69ce4a.jpg";